<template>
  <div>
    <span>{{ price | formatPrice }}</span>
  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/utilities/constants'

export default {
  props: ['data'],
  computed: {
    price() {
      let travelChargePrice = 0

      if (this.task.job.invoiceBy === Constants.INVOICE_BY.MULTIPLE_TASKS) {
        if (this.task.linkedTasks) {
          travelChargePrice = 0
          for (const linkedTask of this.task.linkedTasks) {
            travelChargePrice += _.get(linkedTask, 'fieldValues.travelCharge')
          }
        } else {
          travelChargePrice = _.get(this.task, 'fieldValues.travelCharge')
        }
      } else {
        // not an invoice submittal task
        travelChargePrice = Constants.DO_NOT_DISPLAY_PRICE_VALUE

        // is an invoice submittal task
        if (this.task.name === Constants.TASKS.NAMES.INVOICE_SUBMITTAL) {
          travelChargePrice = _.get(this.task, 'fieldValues.travelCharge')
        }
      }

      return travelChargePrice
    },
    task() {
      return this.data
    }
  }
}
</script>
